var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { View, StyleSheet } from 'react-native';
import styled from 'styled-components/native';
import theme from '../theme';
const Divider = styled((_a) => {
    var { theme, customStyle, defaultProps } = _a, rest = __rest(_a, ["theme", "customStyle", "defaultProps"]);
    return <View {...rest}/>;
}) `
  width: 100%;
  background-color: ${({ theme }) => theme.colorDivider};
  height: ${StyleSheet.hairlineWidth};
  z-index: -1;
  ${({ customStyle }) => customStyle};
`;
Divider.defaultProps = {
    theme: {
        colorDivider: theme.colorDivider,
    },
};
export default Divider;
